<div class="body">
  <img
    class="image"
    src="../../../../assets/images/ic_success_payment.png"
    alt="success check mark"
  />
  <p class="text">{{refundedText}}</p>
</div>
